import RectangleShape from '../model/shapes/rectangleShape'
import CircleShape from '../model/shapes/circleShape'
import SemiCircleShape from '../model/shapes/semiCircleShape'
import OvalShape from '../model/shapes/ovalShape'
import GlassShape from '../model/glassShape'
import RectangleHole from '../model/holes/rectangleHole'
import CircleHole from '../model/holes/circleHole'
import OvalHole from '../model/holes/ovalHole'
import CustomHole from '../model/holes/customHole'
import GlassShapeGroup from '../model/glassShapeGroup'
import GlassDatumLine from '../model/glassDatumLine'
import GlassSplitLine from '../model/glassSplitLine'
import GlassPanelItem from '../model/glassPanelItem'
import AssemblyGroup from '../model/assemblyGroup'


/**
 * Factory utility class for the glass editor
 * Generates objects using classes based on class name
 * Used for deserializing objects from data (undo / loading)
 */
export default class EditorFactory {


  /**
   * Generate a new class based on the class name
   * Returns null if the class name is not found
   */
  static createObject(className, ...args) {
    /**
     * Note: We've added hacks in as the 1st live version used constructor names that were based on minified/uglified classes & were stored in the database
     * This is for backwards compatability
     */

    switch(className) {
      // Shapes
      case 'GlassShape':
        return new GlassShape(...args)
      case 'RectangleShape':
      case 'Zs':
        return new RectangleShape(...args)
      case 'CircleShape':
        return new CircleShape(...args)
      case 'SemiCircleShape':
        return new SemiCircleShape(...args)
      case 'OvalShape':
        return new OvalShape(...args)
      
      // Holes
      case 'RectangleHole':
      case 'Ks':
        return new RectangleHole(...args)
      case 'CircleHole':
      case 'Qs':
        return new CircleHole(...args)
      case 'OvalHole':
        return new OvalHole(...args)
      case 'CustomHole':
        return new CustomHole(...args)

      // Other
      case 'GlassShapeGroup':
      case 'Ns':
        return new GlassShapeGroup(...args)
      case 'GlassDatumLine':
      case 'Zn':
        return new GlassDatumLine(...args)
      case 'GlassSplitLine':
        return new GlassSplitLine(...args)
      case 'GlassPanelItem':
        return new GlassPanelItem(...args)
      case 'AssemblyGroup':
        return new AssemblyGroup(...args)

      default:
        console.error(`EditorFactory Unknown class ${className}`)
    }

    return null
  }
  
}
